import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const currentUrl = useLocation();

  return (
    <nav>
      <ul className="flex justify-between items-center gap-6">
        <Link to="about-us" className="text-sm cursor-pointer hover:underline">
          About Us
        </Link>
        {currentUrl.pathname === "/" ? (
          <a
            className="text-sm cursor-pointer hover:underline"
            href="#features"
          >
            Features
          </a>
        ) : null}

        <Link to="careers" className="text-sm cursor-pointer hover:underline">
          Careers
        </Link>
      </ul>
    </nav>
  );
}

export default Navbar;
